import React, { Fragment, useEffect, useState } from "react";
import { bool } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { Link, SocialShare } from "@quintype/components";

import { AppLogo, Button, HeaderMenuItem, Headline } from "../../../atoms";
import { BUTTONS_DATA, STATIC_KEYWORDS } from "../../../../constants";
import { MEMBER_UPDATED, OPEN_HAMBURGER_MENU } from "../../../store/actions";
import { MenuWithDropdown } from "../../../molecules";
import { NavbarSearch } from "../navbar-search";
import { useSummaryCheck } from "../../../customHooks/useSummaryCheck";
import HamburgerMenu from "../../../atoms/hamburger-menu";
import SummaryCard from "../../../molecules/SummaryCard";
import { SocialShareTemplate } from "../../../../arrow";
import { useDeviceType } from "../../../customHooks/useDeviceType";
import AuthButton from "../../../atoms/AuthButton";
import { addDatalayerEventCollection, getCookie } from "../../../utils";
import { getCategoryAndSubCategory, getTemplateName } from "../../../../ga-utils";
import ToastMessage from "../toastMessage";
import { RightArrow } from "../../../../arrow/components/Svgs/right-arrow";
import OneTapLogin from "../../../atoms/OneTapLogin";

import CompanyIcon from "../../../atoms/CompanyIcon";
import { UserFallbackIcon } from "../../../../arrow/components/Svgs/user-fallback-icon";
import "./top-bar.m.css";
import { EntityListingStory } from "../../../atoms/EntityListingStory";

const TopBar = ({ showOneTap }) => {
  const [shouldShow, setShouldShow] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [memberUpdated, setMemberUpdated] = useState(false);
  // const [loadOneTap, setGoogleOneTap] = useState(false);
  const isMobile = useDeviceType() !== "desktop";
  const dispatch = useDispatch();
  const { SIGN_IN, GO_AD_FREE } = STATIC_KEYWORDS;
  const isAdfree = useSelector((state) => get(state, ["qt", "config", "subscriber"], false));
  const enableSubscription = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "enable_subscription"], false)
  );

  const member = useSelector((state) => get(state, ["member"], null));
  const isHamburgerMenuOpen = useSelector((state) => get(state, ["isHamburgerMenuOpen"], false));
  const hamburgerMenu = useSelector((state) => get(state, ["qt", "data", "navigationMenu", "hamburgerMenu"], []));
  // const GoogleClientId = useSelector((state) =>
  //   get(state, ["qt", "config", "publisher-attributes", "google_client_id"], "")
  // );
  const [logoClick, setLogoClick] = useState(false);

  const displayOverlay = isHamburgerMenuOpen ? ".75" : "0";
  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen,
    });
  };

  const setMember = (member) => {
    console.log("one tap login member updated");
    dispatch({ type: MEMBER_UPDATED, member });
    setMemberUpdated(true);
  };

  const allStates = useSelector((state) => state);
  const qtState = get(allStates, ["qt"], {});
  const config = get(qtState, ["config"]);
  const cdnImage = get(config, ["cdn-image"], "");
  const collection = get(qtState, ["data", "collection"], {});
  const story = get(qtState, ["data", "story"], {});
  const { horizontalDefault } = get(qtState, ["data", "navigationMenu"], {});
  const isWebView = get(qtState, ["config", "isWebView"]) === true;

  const pageType = qtState.pageType;
  const storyHeaderInView = get(allStates, "storyHeaderInView", true);
  const iconSize = { width: "18px", height: "18px" };
  const { summaryPresent, showSummary, setShowSummary, summaryIndex } = useSummaryCheck(story?.cards);
  const [shareURL, setShareURL] = useState("");
  const readEmagazineLink = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "read_emagazine_link"], "")
  );
  const isSubscriptionPage = pageType === "subscription-page";

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const toastMessage = urlParams.get("toastMessage") || "";
    if (toastMessage) {
      setToastMessage(toastMessage);
      urlParams.delete("toastMessage");
      const newSearch = urlParams.toString();
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "");
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  useEffect(() => {
    if (member) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "dl_login_success",
        login_status: "logged-in",
        user_id: `${member?.id}`,
        subscription_status: "not-subscribed",
      });
    }
  }, [member]);

  useEffect(() => {
    let timer;
    if (!storyHeaderInView) {
      timer = setTimeout(() => {
        setShouldShow(true);
      }, 300);
    } else {
      setShouldShow(false);
    }
    if (!storyHeaderInView) {
      !isAdfree && document.getElementById("header").classList.add("sticky-header-top");
    } else {
      !isAdfree && document.getElementById("header").classList.remove("sticky-header-top");
    }
    if (pageType === "company-page" || pageType === "individual-page") {
      if (!storyHeaderInView) {
        !isAdfree && document.getElementById("header").classList.add("different-topbar-top");
      } else {
        !isAdfree && document.getElementById("header").classList.remove("different-topbar-top");
      }
    }
    setShareURL(window.location.href);
    return () => {
      if (timer) clearTimeout(timer);
      !isAdfree && document.getElementById("header").classList.remove("different-topbar-top");
      !isAdfree && document.getElementById("header").classList.remove("sticky-header-top");
    };
  }, [storyHeaderInView]);

  useEffect(() => {
    document.body.style.overflow = showSummary ? "hidden" : "unset";
  }, [showSummary]);

  useEffect(() => {
    if ((pageType === "section-page" || pageType === "collection-page" || pageType === "home-page") && config) {
      addDatalayerEventCollection(collection, config);
    }
  }, [collection]);

  useEffect(() => {
    const qtAuthCookie = getCookie("qt-auth");
    if (logoClick && member && qtAuthCookie) {
      window.location.href = window.location.origin + "/";
    }
  }, [logoClick]);

  useEffect(() => {
    if (memberUpdated) {
      setMemberUpdated(false);
      window.location.reload(window.location.href);
    }
  }, [memberUpdated]);

  const handleLogoClick = () => {
    setLogoClick(true);
    if (typeof window !== "undefined") {
      const categoryInfo = getCategoryAndSubCategory(window.location, pageType, config, story);
      const templateName = getTemplateName(pageType === "story-page" ? story?.["story-template"] : pageType);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "dl_menu_click",
        link_url: "/",
        link_text: "logo",
        link_category: "logo",
        category: categoryInfo.category,
        sub_category: categoryInfo.subCategory,
        content_id: categoryInfo.contentId,
        template_name: templateName,
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };
  const trackPopupSocialShareClick = (platform) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);

      let templateName;
      const isProfilePage = ["individual-page", "company-page"].includes(pageType);
      if (story?.["story-template"]) {
        templateName = getTemplateName(story?.["story-template"]);
      } else if (isProfilePage) {
        templateName = "profilepage";
      } else {
        templateName = getTemplateName(pageType);
      }
      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: "share_click",
        link_text: platform || "share",
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: templateName,
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };
  const hideListenButton = story["story-template"] === "live-blog" || story["story-template"] === "photo";

  const headlineOrMenuItems =
    pageType === "story-page" && shouldShow ? (
      <Headline type={2} customStyleName="ellipsis secondary-header-headline">
        {story?.headline || collection?.name}
      </Headline>
    ) : (
      <ul styleName="menu-items">
        {horizontalDefault?.map((menu, index) => {
          const { title, completeUrl, children } = menu;
          const hrefValue = ["link", "section", "tag"].includes(menu?.["item-type"]) ? completeUrl : "";
          return (
            <Fragment key={`${title}-${index}`}>
              {!children?.length ? (
                <HeaderMenuItem
                  isIconNeeded={false}
                  menuItemvalue={title}
                  href={completeUrl}
                  config={config}
                  story={story}
                />
              ) : (
                <li>
                  <MenuWithDropdown
                    subMenuitems={children}
                    menuItemvalue={title}
                    href={hrefValue}
                    config={config}
                    story={story}
                  />
                </li>
              )}
            </Fragment>
          );
        })}
      </ul>
    );

  const defaultOrSecondaryHeaderBtns = !shouldShow ? (
    <div styleName="btns">
      <AuthButton label={SIGN_IN} path="/user-login" customStyleName="" />
      {enableSubscription && !isSubscriptionPage && !member && (
        <Button socialButton customStyleName="bg-brand-primary" href="/subscription">
          {GO_AD_FREE}
        </Button>
      )}
    </div>
  ) : (
    <div styleName="secondary-header-btns-wrapper">
      <div styleName="secondary-header-btns">
        <EntityListingStory story={story} config={config} isStoryHeader />
        {BUTTONS_DATA.map((item, index) => {
          const {
            iconType = "share",
            iconHeight = iconSize.height,
            iconWidth = iconSize.width,
            customStyleName = "secondary-header-btn",
            text = "",
            ariaLabel,
          } = item;
          if (
            iconType === "play-solid" &&
            (story["story-template"] === "video" ||
              pageType === "author-page" ||
              pageType === "company-page" ||
              pageType === "individual-page" ||
              (story["story-template"] === "magazine" && !member) ||
              story["story-template"] === "sponsored")
          ) {
            return null;
          }
          if (!summaryPresent && iconType === "summary") {
            return null;
          }
          if (iconType === "share") {
            return (
              <SocialShare
                popupText={pageType === "company-page" || pageType === "individual-page" ? "Share this URL" : ""}
                key={index}
                template={(props) => (
                  <SocialShareTemplate
                    {...props}
                    story={story}
                    qtConfig={config}
                    onShareClick={(platform) => trackPopupSocialShareClick(platform?.toLowerCase())}
                  />
                )}
                buttonLabel={hideListenButton ? "Share" : ""}
                fullUrl={encodeURI(story.url) !== "undefined" ? encodeURI(story.url) : encodeURI(shareURL)}
                title={
                  story.headline ||
                  collection?.name ||
                  qtState?.data?.individualInfo?.["display-name"] ||
                  qtState?.data?.companyInfo?.name ||
                  qtState?.data?.query ||
                  qtState?.data?.title ||
                  qtState?.data?.author?.name ||
                  qtState?.data?.top15Label ||
                  ""
                }
                shareIconId={`share-icon-story-share-${story.id}`}
              />
            );
          }

          if (pageType === "section-page" && index <= 1) {
            return null;
          }

          if (summaryPresent && iconType === "summary") {
            if (story["story-template"] === "text" || story["story-template"] === "magazine") {
              const { category, subCategory, contentId } = getCategoryAndSubCategory(
                window.location,
                pageType,
                config,
                story
              );
              return (
                <span
                  key={`${index}-${iconType}`}
                  onClick={(e) => {
                    // Push GA event
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "dl_story_interactions",
                      event_action: "summary_click",
                      category,
                      sub_category: subCategory,
                      content_id: contentId,
                      template_name: getTemplateName(pageType),
                      platform: window.innerWidth >= 768 ? "desktop" : "mobile",
                    });
                    setShowSummary(true);
                  }}
                >
                  <Button
                    iconType={iconType}
                    iconHeight={iconHeight}
                    iconWidth={iconWidth}
                    customStyleName={customStyleName}
                    ariaLabel={ariaLabel}
                  >
                    {text ? <span styleName="btn-text">{text}</span> : ""}
                  </Button>
                </span>
              );
            } else {
              return null;
            }
          }
          return (
            <span key={`${index}-${iconType}`}>
              <Button
                iconType={iconType}
                iconHeight={iconHeight}
                iconWidth={iconWidth}
                customStyleName={customStyleName}
                ariaLabel={ariaLabel}
              >
                {text ? <span styleName="btn-text">{text}</span> : ""}
              </Button>
            </span>
          );
        })}
      </div>
      {/* <Button customStyleName="bg-brand-primary">{GO_AD_FREE}</Button> */}
    </div>
  );
  return (
    <React.Fragment>
      {showOneTap && !isWebView && <OneTapLogin setMember={setMember} member={member} />}

      <div className="topbar-wrapper" styleName={`topbar-wrapper ${!storyHeaderInView ? "moveUpDown" : ""}`}>
        <div styleName="topbar">
          <div styleName="left-wrapper">
            <div styleName="icons-wrapper">
              <div styleName="overlay" onClick={() => toggleHandler()} style={{ opacity: displayOverlay }}></div>
              <HamburgerMenu
                onMenuToggle={() => toggleHandler()}
                isMegaMenuOpen={isHamburgerMenuOpen}
                hamburgerMenu={hamburgerMenu}
              />

              <div styleName="applogo-wrapper" onClick={handleLogoClick}>
                <AppLogo customStyle="app-logo-header" />
              </div>
            </div>
            {!storyHeaderInView && !isMobile && (pageType === "company-page" || pageType === "individual-page") && (
              <div styleName="company">
                {pageType === "company-page" && (
                  <span styleName="photo">
                    {qtState.data.companyInfo?.photo?.[0]?.key ? (
                      <img
                        styleName="image"
                        src={`https://${cdnImage}/${qtState.data.companyInfo?.photo?.[0]?.key}?w=128`}
                      />
                    ) : (
                      <CompanyIcon />
                    )}
                  </span>
                )}
                {pageType === "individual-page" && (
                  <span styleName="photo">
                    {qtState.data.individualInfo?.photo?.[0]?.key ? (
                      <img
                        styleName="image"
                        src={`https://${cdnImage}/${qtState.data.individualInfo?.photo?.[0]?.key}?w=128`}
                      />
                    ) : (
                      <UserFallbackIcon />
                    )}
                  </span>
                )}
                {pageType === "individual-page" ? (
                  <span styleName="name">
                    {qtState?.data?.individualInfo?.["display-name"] || qtState?.data?.individualInfo?.name}
                  </span>
                ) : (
                  <span styleName="name">{qtState?.data?.companyInfo?.name}</span>
                )}
              </div>
            )}
            {pageType === "company-page" || pageType === "individual-page"
              ? storyHeaderInView && headlineOrMenuItems
              : headlineOrMenuItems}
            {!storyHeaderInView && isMobile && (
              <div onClick={handleLogoClick}>
                <AppLogo customStyle="app-logo-header" />
              </div>
            )}
          </div>
          {storyHeaderInView && isMobile && (
            <div styleName="middle-wrapper" onClick={handleLogoClick}>
              <AppLogo customStyle="app-logo-header" />
            </div>
          )}
          <div styleName="right-wrapper" style={!storyHeaderInView ? { gap: "var(--spacing-m)" } : {}}>
            <div styleName={`btn ${!shouldShow ? "active" : ""}`}>
              <NavbarSearch />
            </div>

            {defaultOrSecondaryHeaderBtns}
          </div>
        </div>
        {!storyHeaderInView && isMobile && (pageType === "company-page" || pageType === "individual-page") && (
          <div styleName="company">
            {pageType === "company-page" && (
              <span styleName="photo">
                {qtState.data.companyInfo?.photo?.[0]?.key ? (
                  <img
                    styleName="image"
                    src={`https://${cdnImage}/${qtState.data.companyInfo?.photo?.[0]?.key}?w=128`}
                  />
                ) : (
                  <CompanyIcon />
                )}
              </span>
            )}
            {pageType === "individual-page" && (
              <span styleName="photo">
                {qtState.data.individualInfo?.photo?.[0]?.key ? (
                  <img
                    styleName="image"
                    src={`https://${cdnImage}/${qtState.data.individualInfo?.photo?.[0]?.key}?w=128`}
                  />
                ) : (
                  <UserFallbackIcon />
                )}
              </span>
            )}
            {pageType === "individual-page" ? (
              <span styleName="name">
                {qtState?.data?.individualInfo?.["display-name"] || qtState?.data?.individualInfo?.name}
              </span>
            ) : (
              <span styleName="name">{qtState?.data?.companyInfo?.name}</span>
            )}
          </div>
        )}
        {!storyHeaderInView && isMobile && pageType === "story-page" && story["story-template"] === "magazine" && (
          <Link href={readEmagazineLink} disableAjaxLinks={true}>
            <div styleName="read-e-magazine">
              Read Full E-Magazine
              <RightArrow color="#C6554F" />
            </div>
          </Link>
        )}
      </div>
      {summaryPresent && showSummary && (
        <SummaryCard setShowSummary={setShowSummary} story={story} summaryIndex={summaryIndex} />
      )}
      {showSummary && <div styleName="blur-bg" />}
      {toastMessage && <ToastMessage message={toastMessage} onClose={() => setToastMessage("")} />}
    </React.Fragment>
  );
};

TopBar.propTypes = {
  showOneTap: bool,
};

export { TopBar };
